import {
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoCustomTooltip,
    RaikoDefaultDialogPage,
    RaikoFlexAlignStart,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn, RaikoGridTwoColumn,
    RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {PeriodService} from "../../serverService/periodService/PeriodService";

import "./HabitationMonitoring.scss"
import PieChartWithPaddingAngle from "../../component/charts/pieChartWithPaddingAngle/PieChartWithPaddingAngle";
import PieChartLineInfo from "../../component/charts/pieChartWithPaddingAngle/pieChartLineInfo/PieChartLineInfo";
import {chartColors} from "../../component/charts/utils/ChartColors";
import {HabitationMonitoringService} from "../../serverService/habitationMonitoring/HabitationMonitoringService";
import HabitationMonitoringPieChartHostCapacities
    from "./pieCharts/HabitationMonitoringPieChartHostCapacities";
import HabitationMonitoringPieChartAccommodationReserver
    from "./pieCharts/HabitationMonitoringPieChartAccommodationReserver";
import HabitationMonitoringPieChartAccommodationRequest
    from "./pieCharts/HabitationMonitoringPieChartAccommodationRequest";
import HabitationMonitoringAreaChartDailyPopulation from "./areaCharts/HabitationMonitoringAreaChartDailyPopulation";
import HabitationMonitoringAreaChartDailyCommuting from "./areaCharts/HabitationMonitoringAreaChartDailyCommuting";
import HabitationMonitoringBarChartProvincePopulation from "./barChart/HabitationMonitoringBarChartProvincePopulation";
import RaikoHostSelectBox from "../../component/hostSelect/selectBox/RaikoHostSelectBox";
import HabitationMonitoringAreaChartDailyPopulationPerHost
    from "./areaCharts/HabitationMonitoringAreaChartDailyPopulationPerHost";
import HabitationMonitoringAreaChartDailyCommutingPerHost
    from "./areaCharts/HabitationMonitoringAreaChartDailyCommutingPerHost";
import TotalMeals from "./meals/TotalMeals";
import TotalMealsPerHost from "./meals/TotalMealsPerHost";
import {Helmet} from "react-helmet";

export default function HabitationMonitoring() {

    const periodService = new PeriodService()
    const [selectedPeriod, setSelectedPeriod] = useState(-1)
    const [selectedPeriodTitle, setSelectedPeriodTitle] = useState("")
    const [periodItems, setPeriodItems] = useState([])

    const [periodLoading, setPeriodLoading] = useState(true)

    const [refreshFlag, setRefreshFlag] = useState(false)

    useEffect(() => {
        if (typeof periodService !== "undefined") {
            periodService.getPeriodList(0, 20)
                .then(response => {
                    setPeriodItems([])
                    response.data.map((item, index) => {
                        setPeriodItems(prev => [
                            ...prev,
                            raikoCustomSelectItemGenerator(item.id, item.metaData.title)
                        ])
                    })

                    if (response.data.length > 0) {
                        setSelectedPeriod(response.data[0].id)
                        setSelectedPeriodTitle(response.data[0].metaData.title)
                    }
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {

            })
        }
    }, [])

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag === true) {
            setTimeout(() => {
                setRefreshFlag(false)
            }, 1000)
        }
    }, [refreshFlag]);


    const [openDialog, setOpenDialog] = useState(false)
    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    return <>
        <Helmet>
            <title>{RouteHelper.HabitationReports.name}</title>
        </Helmet>

        <RaikoDefaultDialogPage
            onClose={handleCloseDialog}
            open={openDialog}
            dialogSize={DialogSize.FULL}
            pageTitle={selectedPeriodTitle}
        >

            <div className={css` padding: 0 1rem 1rem 1rem;`}>
                <GetReviewOfShortSystemInfo periodId={selectedPeriod} autoRefresh={true}/>
            </div>

        </RaikoDefaultDialogPage>

        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                {
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.Habitation.name, ""),
                        raikoBreadCrumbItemGenerator("تحلیل و نظارت", ""),
                    ]}/>
                }
            </RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoFlexFirstChildGrowOne className={css`flex-wrap: nowrap;`}>

                    <RaikoCustomSelect
                        labelText={"دروه اسکان دهی"}
                        value={selectedPeriod}
                        setValue={value => {
                            setSelectedPeriod(value)
                            periodItems.map((item) => {
                                console.log("condition is ", parseInt(item.id) === parseInt(value) ," - " , item ," - " ,value)

                                if (parseInt(item.id) === parseInt(value))
                                    setSelectedPeriodTitle(item.name)
                            })
                        }}
                        items={periodItems}
                    />
                    <RaikoButtonPrimary
                        label={" نظارت لحظه ای "}
                        onClick={() => handleOpenDialog()}
                    />
                    <RaikoCustomTooltip title={"بروزرسانی"}>
                        <div>
                            <RaikoButtonSecondary
                                label={"🗘"}
                                className={css`height: 100%;`}
                                onClick={_ => {
                                    setRefreshFlag(true)
                                }}
                            />
                        </div>
                    </RaikoCustomTooltip>
                </RaikoFlexFirstChildGrowOne>
            </RaikoBaseCardContainer>
            <div className={"baseHabitationChartsContainer"}>
                <GetReviewOfShortSystemInfo periodId={selectedPeriod} refreshFlag={refreshFlag}/>
            </div>
            <HabitationMonitoringAreaChartDailyPopulationPerHost periodId={selectedPeriod} refreshFlag={refreshFlag}/>
            <HabitationMonitoringAreaChartDailyCommutingPerHost periodId={selectedPeriod} refreshFlag={refreshFlag}/>
            <TotalMeals refreshFlag={refreshFlag} periodId={selectedPeriod}/>
            <TotalMealsPerHost refreshFlag={refreshFlag} periodId={selectedPeriod}/>
            <HabitationMonitoringBarChartProvincePopulation periodId={selectedPeriod} refreshFlag={refreshFlag}/>
        </RaikoBaseContainer>

    </>
}


function GetReviewOfShortSystemInfo({periodId, refreshFlag, autoRefresh = false}) {

    const service = new HabitationMonitoringService()

    const [doRefreshFlag, setDoRefreshFlag] = useState(false)

    const [hostCapacitiesData, setHostCapacitiesData] = useState([])
    const [hostCapacitiesFilters, setHostCapacitiesFilters] = useState([
        raikoCustomSelectItemGenerator("COUPLE", "مجموع"),
        raikoCustomSelectItemGenerator("MAN", "آقایان"),
        raikoCustomSelectItemGenerator("WOMAN", "خانم ها")
    ])
    const [selectedHostCapacities, setSelectedHostCapacities] = useState(hostCapacitiesFilters[0].id)

    function prepareHostCapacitiesChartItems(total, men, women) {
        return [
            {label: 'آقا', value: men, color: chartColors.blue},
            {label: 'خانم', value: women, color: chartColors.red},
        ]
    }

    useEffect(() => {
        if (typeof autoRefresh !== "undefined" && autoRefresh === true) {
            let intervalId;
            intervalId = setInterval(handleEnableRefreshFlag, 5 * 60 * 1000);
            return () => {
                if (intervalId) clearInterval(intervalId);
            };
        }
    }, [autoRefresh]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag === true) {
            handleEnableRefreshFlag()
        }
    }, [refreshFlag]);

    function handleEnableRefreshFlag() {
        setDoRefreshFlag(true)

        setTimeout(() => {
            setDoRefreshFlag(false)
        }, 1000)
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0) {
            service.getHostCapacities(periodId)
                .then(response => {
                    setHostCapacitiesData({
                        COUPLE: prepareHostCapacitiesChartItems(
                            response.totalPeopleCapacity,
                            response.totalMenCapacity,
                            response.totalWomenCapacity
                        )
                        ,
                        MAN: prepareHostCapacitiesChartItems(
                            response.totalPeopleCapacityOfAutomaticAcceptation,
                            response.totalMenCapacityOfAcceptation,
                            response.totalWomenCapacityOfAcceptation
                        ),
                        WOMAN: prepareHostCapacitiesChartItems(
                            response.totalPeopleCapacityOfAutomaticAcceptation,
                            response.totalMenCapacityOfAutomaticAcceptation,
                            response.totalWomenCapacityOfAutomaticAcceptation
                        )
                    })
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {

            })
        }
    }, [periodId]);


    return (
        <div className={"reviewAllInfoContainer"}>
            <div className={"pieChartsBaseContainer"}>
                <HabitationMonitoringPieChartHostCapacities periodId={periodId} refreshFlag={doRefreshFlag}/>
                <div className={"twoPieChartsContainer"}>
                    <HabitationMonitoringPieChartAccommodationReserver periodId={periodId} refreshFlag={doRefreshFlag}/>
                    <HabitationMonitoringPieChartAccommodationRequest periodId={periodId} refreshFlag={doRefreshFlag}/>
                </div>
            </div>
            <div className={"areChartsBaseContainer"}>
                <HabitationMonitoringAreaChartDailyPopulation periodId={periodId} refreshFlag={doRefreshFlag}/>
                <HabitationMonitoringAreaChartDailyCommuting periodId={periodId} refreshFlag={doRefreshFlag}/>
            </div>
        </div>);
}